import * as React from 'react'

import styled from 'styled-components'

import * as cold from '@owl-nest/cold-data'
import * as ds from '@bob/design-system'

const signatoryCount = Object.entries(cold.brands).reduce((count, [_, value]) => {
  if (value.signatory === true) {
    count += 1
  }
  return count
}, 0)

export function SignatoryCount(): React.ReactElement {
  return (
    <FlexText>
      <Container>
        <Wrapper>
          <ds.Link href="https://www.bienoubien.com/les-marques?bobChart=signatory">
            <ds.styles.copy.Text5>{signatoryCount} marques</ds.styles.copy.Text5>
          </ds.Link>
          {''}ont
        </Wrapper>
        <ds.Tag variant="yellow">
          <ds.icons.Hands />
          <ds.styles.copy.Text5>signé</ds.styles.copy.Text5>
        </ds.Tag>
      </Container>
      <div>la charte Bien ou Bien.</div>
    </FlexText>
  )
}

const Wrapper = styled.div`
  display: flex;

  ${ds.Link} {
    margin-right: 5px;
    ${ds.styles.copy.Text5} {
      font-weight: bold;
    }
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const FlexText = styled(ds.styles.copy.Text5)`
  margin-bottom: 40px;

  > div {
    text-align: center;
  }

  ${ds.Tag} {
    border-radius: 54px;
    margin: 0px 8px;
    padding: 1px 15px;
    line-height: 25px;
    position: relative;
    top: 2px;

    ${ds.styles.copy.Text5} {
      font-weight: 500;
      line-height: 25px;
      position: relative;
      bottom: 2px;
      margin-left: 5px;
    }
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    align-items: center;
    display: flex;
    font-size: 26px;
    justify-content: center;
    margin-bottom: 65px;

    ${ds.Tag} {
      align-items: flex-end;
      padding: 6px 22px;
      top: 2px;

      ${ds.icons.Hands} {
        width: 32px;
        height: 32px;
      }

      ${ds.styles.copy.Text5} {
        font-size: 26px;
        line-height: 35px;
      }
    }
  }
`
